import { Loader as MantineLoader, LoaderProps } from '@mantine/core';

export type ILoaderProps = LoaderProps;

/** @registry Design-layer pass-through over Mantine Loader; import this instead of @mantine/core Loader outside src/design. */
export const Loader = MantineLoader;
